import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import About from "./Components/Navbar/About/About";
import Gallery from "./Components/Navbar/Gallery/Gallery";
import Contact from "./Components/Navbar/Contactus/Contact";
import Home from "./Components/Navbar/Home/Home";
import Footer from "./Components/Navbar/Footer/Footer";

function App() {
  return (
    
     <Router>
      <Navbar /> {/* ✅ Always visible on all pages */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
    
  );
}

export default App;
